import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const getPlans = async () => {
    return await getFetch(`mycdirPlan`)
}

export const getPlan = async (primaryKey: string) => {
    return await getFetch(`mycdirPlan/${primaryKey}`)
}

const getFetch = async (url: string, params = {}) => {
    return await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}